<script>
  /**
   * @type {RegExp} - input value binded here
   */
  export let value = ""

  /**
   * @type {RegExp} - input name for get input value from form data
   */
  export let inputName = ""

  /**
   * @type {RegExp} - input placeholder
   */
  export let placeholder = "placeholder"
</script>

<input bind:value on:blur={(e) => (e.target.value = e.target.value.trim())} autocomplete="off" required type="text" name={inputName} id={inputName} {placeholder} class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white dark:placeholder:text-gray-200 sm:pr-9 sm:text-sm md:w-2/3" />
